import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css"; 

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailSubmit = async () => {
    if (!email) {
      toast.warn("Please enter your registered email.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (!validateEmail(email)) {
      toast.error("Invalid email format. Please enter a valid email.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    try {
      const response = await apiService.postData("admin/generate-otp", { email });
      const { error, message } = response.data || {};

      toast[error ? "error" : "success"](message || "OTP has been sent successfully.", {
        position: "top-right",
        autoClose: 2000,
        onClose: () => {
          navigate("/verify-otp", { state: { email, message } });
        },
      });
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }
  };

  return (
    <div className="container mt-5">
      <ToastContainer />
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="text-center">
            <img
              src="assets/img/logo.png"
              alt="logo"
              width="250"
            />
          </div>
          <div className="card card-primary">
            <div className="card-header text-center">
              <h4>Forgot Password</h4>
            </div>
            <div className="card-body">
              <p className="text-muted text-center">We will send a link to reset your password</p>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>
              <div className="form-group">
                <button className="btn btn-primary btn-lg btn-block w-100" onClick={handleEmailSubmit}>
                  Send OTP
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
